import { Component, Input, forwardRef, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GoogleMap } from '@agm/core/services/google-maps-types';
declare let google: any;

const defaultLocation: LocationModel = {
  longitude: 26.60259140800376,
  latitude: 29.78763147799509
};
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MapComponent),
      multi: true
    }
  ]
})
export class MapComponent implements OnChanges, ControlValueAccessor {

  mapType = 'roadmap';
  zoom = 10;
  animation = 'DROP';

  mapCenter: LocationModel = defaultLocation;
  marker: LocationModel;

  private _mapRef: GoogleMap;

  @Input() cityName ? = 'cairo, Egypt';

  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};

  ngOnChanges() {
    this.updateMapCenter();
  }

  mapReady(map: GoogleMap) {
    this._mapRef = map;
    this.updateMapCenter();
  }

  writeValue(obj: any): void {
    this.marker = obj;
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  markerDragEnd(event: any) {
    this._onChange(this.marker);
  }

  placeMarker(postion: any) {
    this.marker = {
      latitude: postion.coords.lat,
      longitude: postion.coords.lng
    };
    this._onChange(this.marker);
  }


  private updateMapCenter() {
    if (this._mapRef && this.cityName) {
      const request = {
        query: this.cityName,
        fields: ['name', 'geometry']
      };
      const service = new google.maps.places.PlacesService(this._mapRef);
      service.findPlaceFromQuery(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          this._mapRef.setCenter(results[0].geometry.location);
        }
      });
    }
  }
}

interface LocationModel {
  longitude: number;
  latitude: number;
}
